<div [ngClass]="{ mobile: isOnMobile, desktop: !isOnMobile }">
  <div class="hero-wrapper">
    <div *ngIf="uiState === SmartFixUIState.Idle">
      <video
        #introVideo
        alt="Smart fix animation"
        class="hero-element intro-video"
      ></video>
      <video
        #transitionVideo
        alt="Smart fix transition"
        class="hero-element transition-video"
        (ended)="onVideoEnded()"
      ></video>
    </div>
    <img
      [src]="
        uiState === SmartFixUIState.Feedback
          ? './assets/svg/smart-fix-static-feedback.svg'
          : './assets/svg/smart-fix-static-desktop.svg'
      "
      alt="Smart fix static"
      [class]="
        'hero-element static' +
        (uiState === SmartFixUIState.Chat ||
        uiState === SmartFixUIState.Feedback
          ? ' show'
          : '')
      "
    />
  </div>
</div>
